import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

import MDActionConfigurator from "components/MDActionConfigurator";

import { complaintPosting, complaintUpdating } from "actions/complaintActions";
import { getClientList } from "actions/clientActions";

function CreateComplaintButton({ selectProduct }) {
  const configuratorRef = useRef(null);
  const dispatch = useDispatch();
  const [selectClient, setSelectClient] = useState([]);
  const [currentState, setCurrentState] = useState("");
  const [currentData, setCurrentData] = useState({
    _id: "",
    complaintNumber: "",
    product: "",
    client: "",
    description: "",
    amount: 0,
    responseRequirements: [],
  });

  const listClients = useSelector((state) => state.listClients);
  const { clientsList } = listClients;

  useEffect(() => {
    if (clientsList?.length === 0) {
      dispatch(getClientList());
    }
    setSelectClient(
      clientsList?.map((item) => ({
        value: item._id,
        name: item.name,
      }))
    );
  }, [dispatch, clientsList?.length]);

  const handleToggleBackdrop = (item, state) => {
    setCurrentData(item);
    setCurrentState(state);
    if (configuratorRef.current) {
      configuratorRef.current.handleToggleConfigurator();
    }
  };

  const handleSubmitComplaint = (e) => {
    if (currentState === "edit") {
      dispatch(complaintUpdating(currentData?._id, e));
    } else {
      dispatch(complaintPosting(e));
    }
    handleToggleBackdrop({}, "");
  };

  return (
    <MDBox display="flex" alignItems="center" lineHeight={0}>
      <MDBox mt="auto">
        <MDButton
          component="a"
          href="#"
          rel="noreferrer"
          variant="gradient"
          color="info"
          onClick={() =>
            handleToggleBackdrop(
              {
                _id: "",
                complaintNumber: "",
                product: "",
                client: "",
                description: "",
                amount: 0,
                responseRequirements: [],
              },
              ""
            )
          }
        >
          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
          &nbsp;Make Complaint
        </MDButton>
      </MDBox>

      <MDActionConfigurator
        ref={configuratorRef}
        title="Complaint Config"
        subtitle={`Complaint for ${selectProduct?.service?.service} product: ${selectProduct?.productName} - ${selectProduct?.productNumber} under supplier: ${selectProduct?.supplier?.supplierName}`}
        productAmount={selectProduct?.amount}
        onCompleteConfig={handleSubmitComplaint}
        data={[
          {
            keyType: "_id",
            valueType: currentData?._id,
          },
          {
            labelType: "Selected Product",
            placeholderType: "Selected Product",
            dataType: "disabled",
            keyType: "product",
            valueType: selectProduct?._id,
          },
          {
            labelType: "Complaint Number",
            placeholderType: "Enter Complaint Number",
            dataType: "text",
            keyType: "complaintNumber",
            valueType: currentData?.complaintNumber,
          },
          {
            labelType: "Client",
            placeholderType: "Select Client",
            dataType: "select",
            keyType: "client",
            valueType: currentData?.client,
            options: selectClient,
          },
          {
            labelType: "Description",
            placeholderType: "Enter Description",
            dataType: "text",
            keyType: "description",
            valueType: currentData?.description,
          },
          {
            labelType: "Complaint Amount",
            placeholderType: "Enter Complaint Amount",
            dataType: "number",
            keyType: "amount",
            valueType: currentData?.amount,
          },
          {
            labelType: "Requirements",
            placeholderType: "Select Requirements",
            dataType: "complaintrequirement",
            keyType: "responseRequirements",
            valueType: currentData?.responseRequirements
              ? currentData?.responseRequirements
              : [],
            options: selectProduct?.complaintRequirements
              ? selectProduct?.complaintRequirements
              : [],
          },
        ]}
        state={currentState}
      />
    </MDBox>
  );
}

export default CreateComplaintButton;
